export default {
  try: 'Try',
  recommendation: 'recommendation',
  noProducts: 'No Products',
  showInactive: 'SHOW INACTIVE',
  product: 'Product',
  price: 'Price',
};
